import { Component } from 'react'
import { Benefit } from '../../../../../../insfrastructure/services/benefits';
import { Input } from '../../../../../components/input';
import { Select } from '../../../../../components/select';
import './styles.sass'

interface Props {
    name: string,
    label?: string,
    options: Benefit[],
    disabled?: boolean,
    readonly?: boolean,
    single?: boolean,
    initialValue?: SelectedBenefit[],
    onChange: (value: SelectedBenefit[]) => any
}

export interface SelectedBenefit {
    benefit_id: number,
    value?: string,
    time_unit?: string,
    description?: string
}

interface State {
    currentValue: SelectedBenefit[],
    options: Benefit[]
}

export default class BenefitsList extends Component<Props> {
    state: State = {   
        currentValue: [],
        options: []
    }

    componentDidMount() {        
        this.setState({ 
            options: this.props.options, 
            currentValue: this.props.initialValue || [] 
        });
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
        if(prevProps.initialValue !== this.props.initialValue) {
            this.setState({ currentValue: this.props.initialValue || [] });
        };
        if(prevProps.options !== this.props.options) {
            this.setState({ options: this.props.options });
        };
    }

    onSelect = (option: Benefit) => {
        if (this.state.currentValue?.filter(x => x.benefit_id === option.id).length === 0) {
            this.setState({
                currentValue: [
                    ...this.state.currentValue,
                    {
                        benefit_id: option.id
                    }
                ]
            });

            this.props.onChange([
                ...this.state.currentValue,
                {
                    benefit_id: option.id
                }
            ]);
        } else {
            this.setState({
                currentValue: this.state.currentValue.filter(x => x.benefit_id !== option.id)
            });

            this.props.onChange(this.state.currentValue.filter(x => x.benefit_id !== option.id));
        };
    }

    onChangeExtraInput = (option: Benefit, field_name: string, e: any) => {
        const selected_benefits = this.state.currentValue.map((x: any) => {
            if (x.benefit_id === option.id) {
              return { ...x, [field_name]: e };
            };
            return x;
        });

        this.setState({
            currentValue: selected_benefits
        });

        this.props.onChange(selected_benefits);
    }

    getCurrentIndexFieldValue = (option: Benefit, field_name: string) => {
        const selectedOption: any = this.state.currentValue.find((x) => x.benefit_id === option.id);
        if(!selectedOption) {
            return '';
        };

        return selectedOption[field_name];
    }

    render() {
        return (
            <div className={'benefits-list '+(this.props.disabled ? 'disabled' : '')}>
                {this.props.label && <label>{this.props.label}</label>}
                <div className='options'>
                    {
                        this.props.options && this.props.options.map((x, i: number) => 
                        <div key={'radio_option_'+i+'_'+x.id} className='option'>
                            <div className='input-container' onClick={() => this.onSelect(x)}>
                                <input
                                name={this.props.name}
                                type='checkbox'
                                checked={this.state.currentValue.map((v: any) => v.benefit_id).includes(x.id)}
                                readOnly />
                                <span>{x.name} {this.state.currentValue.map((v: any) => v.benefit_id).includes(x.id)}</span>
                            </div>
                            {(x.has_value || x.has_time_unit) && 
                            <div className='extra-inputs'>
                                {
                                    x.has_value &&
                                    <Input
                                    name={x.id+'_value'}
                                    type={'money'}
                                    placeholder={x.has_time_unit ? 'Valor do benefício' : 'Valor do benefício (ex: R$ 500,00)'}
                                    value={this.getCurrentIndexFieldValue(x, 'value')}
                                    disabled={!this.state.currentValue.map((v: any) => v.benefit_id).includes(x.id)}
                                    onChange={e => this.onChangeExtraInput(x, 'value', e)}
                                    />
                                }
                                {
                                    x.has_time_unit &&
                                    <Select
                                    name={x.id+'_time_unit'}
                                    placeholder={x.has_value ? 'Frequência' : 'Frequência (ex: por dia, por mês)'}
                                    options={[
                                        {
                                            label: 'por dia',
                                            value: 'day'
                                        },
                                        {
                                            label: 'por mês',
                                            value: 'month'
                                        }
                                    ]}
                                    value={this.getCurrentIndexFieldValue(x, 'time_unit')}
                                    disabled={!this.state.currentValue.map((v: any) => v.benefit_id).includes(x.id)}
                                    onChange={e => this.onChangeExtraInput(x, 'time_unit', e)}
                                    />
                                }

                            </div>}
                        </div>)
                    }
                </div>
            </div>
        )
    }
}
